<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900">Email Campaign Statistics</h3>
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-4">
      <BaseCard
        class="cursor-pointer"
        @click="$emit('switch-tab', { tab: 'send_logs', options: { defaultQueryParams: {} } })"
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Recipients (Unique)</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ recipientsCount }} ({{ emailAddressesCount }})
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard
        class="cursor-pointer"
        @click="
          $emit('switch-tab', {
            tab: 'send_logs',
            options: { defaultQueryParams: { filter: { status: 'SENT' } } },
          })
        "
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Sent</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ emailAddressesSentCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard
        class="cursor-pointer"
        @click="
          $emit('switch-tab', {
            tab: 'send_logs',
            options: { defaultQueryParams: { filter: { status: 'FAILED' } } },
          })
        "
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Failed</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ emailAddressesFailedCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard
        class="cursor-pointer"
        @click="
          $emit('switch-tab', {
            tab: 'send_logs',
            options: { defaultQueryParams: { filter: { unsubscribed: 1 } } },
          })
        "
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Unsubscribed</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ unsubscribedCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard
        class="cursor-pointer"
        @click="
          $emit('switch-tab', {
            tab: 'send_logs',
            options: { defaultQueryParams: { filter: { bounced: 1 } } },
          })
        "
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Bounced</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ bouncedCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard
        class="cursor-pointer"
        @click="
          $emit('switch-tab', {
            tab: 'send_logs',
            options: { defaultQueryParams: { filter: { opened: 1 } } },
          })
        "
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Opens (Unique)</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ openCount }} ({{ uniqueOpenCount }})
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard
        class="cursor-pointer"
        @click="
          $emit('switch-tab', {
            tab: 'send_logs',
            options: { defaultQueryParams: { filter: { clicked: 1 } } },
          })
        "
      >
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Clicks (Unique)</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ clicksCount }} ({{ uniqueClicksCount }})
          </dd>
        </BaseCardBody>
      </BaseCard>
    </dl>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    recipientsCount() {
      return Numbro(this.emailCampaign.recipients_count || 0).format({ thousandSeparated: true });
    },
    emailAddressesCount() {
      return Numbro(this.emailCampaign.email_addresses_count || 0).format({
        thousandSeparated: true,
      });
    },
    emailAddressesSentCount() {
      return Numbro(this.emailCampaign.email_addresses_sent_count || 0).format({
        thousandSeparated: true,
      });
    },
    emailAddressesFailedCount() {
      return Numbro(this.emailCampaign.email_addresses_failed_count || 0).format({
        thousandSeparated: true,
      });
    },
    openCount() {
      return Numbro(this.emailCampaign.open_count || 0).format({
        thousandSeparated: true,
      });
    },
    uniqueOpenCount() {
      return Numbro(this.emailCampaign.unique_open_count || 0).format({
        thousandSeparated: true,
      });
    },
    clicksCount() {
      return Numbro(this.emailCampaign.clicks_count || 0).format({
        thousandSeparated: true,
      });
    },
    uniqueClicksCount() {
      return Numbro(this.emailCampaign.unique_clicks_count || 0).format({
        thousandSeparated: true,
      });
    },
    unsubscribedCount() {
      return Numbro(this.emailCampaign.unsubscribed_count || 0).format({
        thousandSeparated: true,
      });
    },
    bouncedCount() {
      return Numbro(this.emailCampaign.bounced_count || 0).format({
        thousandSeparated: true,
      });
    },
  },
};
</script>
